import React, { Component } from 'react';
import Select from '../Select/Select';

export default class OwnerForm extends Component {
	render() {
		const {
			show,
			form: { selects, cta },
			selectClicked,
			selectItemClicked,
			submitted,
			closed
		} = this.props;

		const formClass = ['Form', show ? 'is-visible' : ''].join(' ');

		let disableButton = true;

		const selectsTpl = selects.map(field => {
			if (field.type === 'select') {
				disableButton =
					disableButton &&
					(typeof field.value === 'string' && field.value.trim() !== '');

				return (
					<Select
						key={field.name}
						clicked={selectClicked}
						itemClicked={selectItemClicked}
						placeholder={field.placeholder}
						name={field.name}
						value={field.value}
						showList={field.showList}
						styles={{ marginRight: '20px', width: '190px', ...field.styles }}
						items={field.options}
					/>
				);
			} else {
				return null;
			}
		});

		return (
			<div className={formClass}>
				<button className="Form-close" onClick={closed}>
					Close
				</button>
				<div
					className="Form-content"
					style={{
						justifyContent: 'flex-start',
						alignItems: 'center',
						marginBottom: '20px',
						position: 'absolute',
						top: '40px'
					}}
				>
					<div className="Form-field">
						<label className="Form-label">Add an owner for this session</label>
						<div>{selectsTpl}</div>
					</div>
					<button
						disabled={!disableButton}
						className="Form-button"
						onClick={submitted}
					>
						{cta}
					</button>
				</div>
			</div>
		);
	}
}
